<template>
  <Header v-show="$store.state.labelType == 1 || $store.state.labelType == 0" class="layout-header">
    <!-- 置顶应用 - 只在应用路由（labelType === 0）时显示 -->
    <div class="top-plugin-body" v-show="$store.state.labelType == 0">
      <div class="top-plugin-item" v-for="(item, index) in $store.state.topPlugin" :key="index" @click="handleTopPluginClick(item)">
        <div class="top-plugin-icon">
          <Avatar :src="$fullImage(item.icon)" shape="square" size="24"/>
        </div>
        <div class="top-plugin-name"> {{ item.name }}</div>
      </div>
    </div>
    <!-- 置顶应用 END -->
    <div class="header-info-wrapper">
      <HeaderInfo></HeaderInfo>
    </div>
  </Header>
</template>

<script>
export default {
  components: {
    HeaderInfo: () => import('@/components/layout/headerInfo.vue')
  },
  methods: {
    // 新增：处理置顶应用点击
    handleTopPluginClick (item) {
      if (item.menu.length > 0) {
        this.toUrl(item.menu[0].path) // 跳转到应用菜单的第一个页面
        this.$store.dispatch('setSubMenu', item.menu) // 设置子菜单
        this.$store.dispatch('setShowSubMenu', true) // 显示子菜单
      }
    }
  }
}
</script>

<style scoped>

.layout-header {
  background-color: #fff;
  padding: 0 40px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid #e8eaec;
}

/* 置顶 */
.top-plugin-body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 30px;
  row-gap: 2px;
  margin-right: 10px;
}

.top-plugin-item {
  display: flex;
  line-height: 24px;
  cursor: pointer;
}

.top-plugin-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 18px;
  font-weight: 500;
  color: rgba(56, 56, 56, 1);
  margin-left: 10px;
}

.header-info-wrapper {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  min-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/commonHeader.vue